<template lang="pug">
.v-basket.basket
	v-loader(:loading="loading")
	.basket__container.container

		template(v-if="!basket.items || !basket.items.length")
			.basket__empty(v-if="basket.emptyMessage" v-html="basket.emptyMessage")

		template(v-else-if="basket.success && basket.successMessage")
			.basket__empty(v-html="basket.successMessage")

		template(v-else)
			.basket__wrap(v-if="basket.items && basket.items.length")
				.basket__products
					template(v-for="(item, itemIndex) in basket.items" :key="itemIndex")
						.basket__product.flc
							v-product(template="basket-list" :product="item" @delete-product="deleteBasketItem(item.id)")
				.basket__resume
					.basket__sticky-wrap
						.basket__sum(v-if="basket.resume.totalPrice && basket.resume.totalPrice.current.value > 0")
							.basket__sum-title Итого:
							v-price(:price="basket.resume.totalPrice" size="lg")
						template(v-if="basket.resume.basketParams")
							.basket__params
								template(v-for="(basketParam, basketParamIndex) in basket.resume.basketParams" :key="basketParamIndex")
									.basket__param.flc
										.basket__param-name {{basketParam.name}}
										.basket__param-value
											v-price(:price="basketParam.price")
						.basket__promocode(v-if="basket.fieldCertCode")
							.basket__promocode-wrap
								.basket__promocode-field
									v-field(:field="basket.fieldCertCode" :errors="computedfieldCertCodeError" v-model="basket.giftCertCode")
								.basket__promocode-action
									button.basket__aside-btn.btn.btn--primary(type="button" @click="applyCertCode") Применить
						.basket__action
							button.btn.btn--primary.btn--lg.btn--block(type="button" @click="requestDataLoadNextStep" :disabled="isFormsHasErrors")
								| Перейти к оформлению
						.basket__footer
							button.link(type="button" @click="requestDataLoadCustom('cleanBasket')") Очистить корзину

			.basket__form-wrap(ref="basketFormWrap" v-if="basket.resume.totalPrice && basket.resume.totalPrice.current.value > 0")
				h2.basket__title-form.h2(v-if="!basket.success && basket.step > 0") Оформление заказа

				template(v-if="basket.steps")
					template(v-for="(stepData, stepDataIndex) in basket.steps" :key="stepDataIndex")
						.basket__params-list(v-if="stepData.number && stepData.number < basket.step")
							h4.flc {{stepData.title}}
							.basket__key-value-list
								.key-value-list.flc
									template(v-for="(fieldParam, fieldParamIndex) in basket.forms[stepData.code].fields" :key="fieldParamIndex")
										.key-value-list__item(v-if="fieldParam.viewValue && fieldParam.type !== 'hidden'")
											.key-value-list__item-start(v-if="fieldParam.label || fieldParam.placeholder") {{fieldParam.label || fieldParam.placeholder}}
											.key-value-list__item-spacer(v-if="fieldParam.label || fieldParam.placeholder")
											.key-value-list__item-end {{fieldParam.viewValue}}
									.key-value-list__footer
										button.link(type="button" @click="changeStep(stepData.number)")
											.link-underline__inner Изменить данные

				.basket__form(v-if="currentForm")
					template(v-if="currentForm && currentForm.success && currentForm.message")
						.form__success-message(v-html="form.message")
					template(v-if="currentForm && !currentForm.success")
						form.form.form--card(@submit.prevent="submit", novalidate, autocomplete="off")
							.form__header.flc.fcc(v-if="currentStep.title || currentStep.note")
								h3.form__header-title.flc(v-if="currentStep.title") {{currentStep.title}}
							.form__main.flc.fcc
								template(v-if="basket.errors && basket.errors.form && basket.errors.form.length")
									.form__form-errors
										template(v-if="Array.isArray(basket.errors.form) && basket.errors.form.length")
											template(v-for="(error, errorIndex) in basket.errors.form" :key="errorIndex")
												.form__form-error.flc(v-html="error")
										template(v-else)
											.form__form-error.flc(v-html="basket.errors.form")
								.form__groups
									template(v-for="(group, groupIndex) in currentForm.groups" :key="groupIndex")
										.form__group(:style="{width: group.width || null}")
											h4.form__group-title.flc(v-if="group.title") {{group.title}}
											.form__group-note.flc(v-if="group.note" v-html="group.note")
											.form__group-body.flc
												.form__fields
													template(v-for="(field, fieldIndex) in currentForm.fields" :key="fieldIndex")
														template(v-if="field.groupId === group.id")
															.form__field(:style="{width: field.width || null}")
																v-field(:field="field"
																		:errors="getFieldError(field)"
																		v-model="field.value"
																		@update:model-value="fieldChanged(field, $event)")
							.form__footer.flc
								.form__actions
									.form__action(v-if="currentStep")
										button.btn.btn--primary.btn--lg(type="buttom" @click="changeStep(currentStep.number + 1)") {{currentStep.nextButton}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';
import controller from '../scripts/controller/controller';
import {mapGetters} from 'vuex';

export default {
	mixins: [
		sourceMixin,
		formattingMixin
	],

	data() {
		return {
			basket: {
				remote: '',
				items: [],
				step: null,
				forms: null,
				steps: null,
				resume: {
					basketParams: null,
					totalPrice: null
				},
				authorized: null,
				fieldCertCode: null,
				giftCertCode: null,
				giftCertCodeError: null,
			},
			touch: controller.touch,
			currentStep: null,
			currentForm: null,
			localFormData: new FormData(),
			savedFileKeys: [],
			isFormsHasErrors: false
		};
	},

	computed: {
		...mapGetters({
			itemsBasket: 'basket/items',
			itemsFavorite: 'favorite/items'
		}),

		computedfieldCertCodeError() {
			return this.basket.giftCertCodeError ? [
				{
					name: this.basket.fieldCertCode,
					message: [
						this.basket.giftCertCodeError
					]
				}
			] : null;
		}
	},

	watch: {
		itemsBasket() {
			this.requestDataLoad();
		},

		itemsFavorite() {
			this.requestDataLoad();
		}
	},

	methods: {
		valueRemove() {

		},

		chackHasFormsErrors() {
			let result = false;
			if (this.basket.forms) {
				Object.keys(this.basket.forms).forEach(form => {
					let currentForm = this.basket.forms[form];
					if (currentForm.errors &&
						((currentForm.errors.form && currentForm.errors.form.length) ||
							(currentForm.errors.fields && Object.keys(currentForm.errors.fields).length))) {
						result = true;
					}
				});
			}
			this.isFormsHasErrors = result;
		},

		applyCertCode() {
			let $self = this;
			$self.dataLoad({
				url: $self.basket.remote,
				delay: true,
				data: {
					action: 'applyCertCode',
					giftCertCode: this.basket.giftCertCode
				}
			});
		},

		getFieldError(field) {
			let $self = this;
			if ($self.basket.errors && $self.basket.errors.fields) {
				let filteredErrors = [];
				Object.keys($self.basket.errors.fields).forEach(fieldCode => {
					if (fieldCode === field.id) {
						filteredErrors.push($self.basket.errors.fields[fieldCode]);
					}
				});
				return filteredErrors.length ? filteredErrors : null;
			} else {
				return null;
			}
		},

		deleteBasketItem(productId) {
			let $self = this;
			$self.dataLoad({
				url: $self.basket.remote,
				delay: true,
				data: {
					action: 'remove',
					items: productId
				}
			}).then(() => {
				controller.updateModelSource();
			});
		},

		requestDataLoadCustom(action) {
			let $self = this;
			$self.dataLoad({
				url: $self.basket.remote,
				delay: true,
				data: {
					action: action,
					stepValue: $self.basket.step
				}
			}).then(function () {
				controller.updateModelSource('basket');
			});
		},

		changeStep(setStep) {
			let $self = this;
			if (setStep < $self.basket.step) {
				$self.basket.step = setStep;
				$self.requestDataLoadNextStep();
			}
			if (setStep > $self.basket.step) {
				$self.requestDataLoadNextStep(true);
			}
		},

		requestDataLoadNextStep(submit, options = {}) {
			const $self = this;
			if ($self.loading) {
				return;
			}
			let namesOfCurrentIteration = [];
			if ($self.basket.forms) {
				Object.keys($self.basket.steps).forEach(stepKey => {
					$self.basket.forms[stepKey]['fields'].forEach(field => {
						let key = $self.proxyFieldName(field.name);
						if (field.multiple) {
							key = this.proxyFieldName(field.name.replace('[]', '')) + '[]';
						}
						if (!field.value) {
							field.value = '';
						}
						if (field.type === 'file') {
							// очистка полей для файлов от старых значений
							for (let item of $self.localFormData.entries()) {
								let isfoundInSavedFileKeys = false;
								for (let j = 0; j < $self.savedFileKeys.length; j++) {
									if (item[0].indexOf($self.savedFileKeys[j]) > -1) {
										isfoundInSavedFileKeys = true;
										break;
									}
								}
								if (item[0].indexOf(key) === 0 && !isfoundInSavedFileKeys) {
									$self.localFormData.delete(item[0]);
								}
							}
						}
						if (namesOfCurrentIteration.indexOf(key) < 0) {
							$self.localFormData.delete(key);
							namesOfCurrentIteration.push(key);
						}
						if (field.type !== 'file') {
							if (Array.isArray(field.value)) {
								field.value.forEach(val => {
									$self.localFormData.append(key, val);
								});
							} else {
								$self.localFormData.append(key, field.value);
							}
						}
					});
				});
			}
			$self.localFormData.set('state[action]', options.action || 'submit');
			$self.localFormData.set('bxajaxid', $self.bxajaxid);
			$self.localFormData.delete('stepValue');
			if ($self.currentStep) {
				$self.localFormData.append('stepValue', (submit ? ($self.currentStep.number + 1) : $self.basket.step));
			}
			this.dataLoad({
				url: $self.basket.remote,
				data: $self.localFormData,
				delay: true
			}).then(() => {
				this.chackHasFormsErrors();
			});
		},

		requestDataLoad(id) {
			const $self = this;
			if ($self.loading) {
				return;
			}
			$self.dataLoad({
				url: $self.basket.remote,
				delay: true,
				data: {
					action: 'load',
					id: id
				}
			});
		},

		dataSet(data) {
			if (data.basket.resume.reload) {
				window.location = data.basket.resume.reload;
				return;
			}
			this.basket = data.basket;
			let currentStep;
			Object.keys(data.basket.steps).forEach(key => {
				let item = data.basket.steps[key];
				if (item.number === data.basket.step) {
					currentStep = item;
				}
			});
			if (currentStep) {
				this.currentStep = currentStep;
				this.currentForm = data.basket.forms[currentStep.code];
			}
		},

		submit() {
			this.requestDataLoadNextStep(true);
		},

		fieldChanged(field) {
			if (field.autosubmit) {
				this.requestDataLoadNextStep(false);
			}
		},

		proxyFieldName(name) {
			return `state[form][${name}]`;
		},

		fileInput(field, e) {
			this.savedFileKeys = [];
			for (let i = 0; i < e.target.files.length; i++) {
				this.savedFileKeys.push(e.key);
				this.localFormData.append(this.proxyFieldName(field.name) + '[' + e.key + ']', e.target.files[i].path || e.target.files[i]);
			}
		},

		fileRemove(field, e) {
			this.localFormData.delete(this.proxyFieldName(field.name) + '[' + e.key + ']');
		}
	}
};

</script>